export default "__VITE_ASSET__8K4wAS5Y__"